import React, { useState } from 'react'
import arrow from '../../Images/Group (5).png'
import arrow2 from '../../Images/Group (7).png'
import location from '../../Images/fi_2838912.png'
import bookmark from '../../Images/Vector (23).png'
import HttpClientXml from '../../utils/HttpClientXml'
import { toast } from 'react-toastify'
import "./Career.css";
import HomeService from '../../Services/HomeService'
const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '50%',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
  }
};

const FeaturedJobs = ({ data, loading, listingTitle }) => {

  console.log("NHTT29", listingTitle);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialFormData = {
    jobId: "",
    name: "",
    email: "",
    phone: "",
    cvFile: ""
  }
  const [formData, setFormData] = useState(initialFormData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('SEE48', formData);
    // return
    try {
      const response = await HomeService.applyJob(formData);
      console.log("XDE45", response);

      if (response?.status) {
        setFormData(initialFormData)
        toast.success(response.message)
      }
    } catch (err) {
      console.error("Error", err);
    }
    setIsModalOpen(false); // Close modal after submit
  };

  const handleAttachmentUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("cvFile", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "file-upload",
          "POST",
          data
        );
        console.log("UYTRE59", res);

        if (res?.status && res?.doc) {
          setFormData({ ...formData, [e.target.name]: res.doc })
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      }
    }

    // setImages((prevImages) => [...prevImages, ...uploadedImages]);
    // toast.success("Images uploaded successfully!");
  };


  return (
    <>
      <div className='featured_jobs_wrapper'>
        <div className='d-flex justify-content-between align-items-center featured_head_div'>
          <h1>{listingTitle}</h1>
          {/* <button className='view_all_btn'>View All 
      <img src={arrow}/>
      </button> */}
        </div>

        <div className='featured_jobs_div_wrapper'>
          {loading && "Loading..."}
          {
            data.length > 0 ? (
              <>
                {
                  data.map((item, key) => {
                    return (
                      <>
                        <div className='feature_jobs' key={key}>
                          <div className='left_jobs_div'>
                            <div className='job_post_wrapper'>
                              <h4>{item?.jobTitle}</h4>
                              <button>{item?.category?.catName}</button>
                            </div>
                            <p className='job_type'>{item?.jobType} Job</p>
                            <p className='job-desc'>{item?.jobDescription || ""}</p>
                            <div className='job_details_wrapper'>
                              <p><img src={location}></img> {item?.location}</p>
                              <p><i class="fa fa-indian-rupee-sign"></i>{item?.salary}</p>
                              {/* <p>4 Days Remaining</p> */}
                            </div>
                          </div>
                          <div className='right_jobs_div'>
                            {/* <div className='bookmark_div'>
                              <img src={bookmark} />
                            </div> */}
                            <button
                              onClick={() => {
                                setFormData({ ...formData, jobId: item?._id })
                                setIsModalOpen(true)
                              }}
                            >Apply Now
                              <img src={arrow2} /></button>
                          </div>


                        </div>
                      </>
                    )
                  })
                }
              </>
            ) : (
              <>No records found!</>
            )

          }



          {/* <div className='feature_jobs'>
            <div className='left_jobs_div'>
              <div className='job_post_wrapper'>
                <h4>Senior UX Designer</h4>
                <button>Development & IT</button>
              </div>
              <p className='job_type'>Full-Time Job</p>
              <div className='job_details_wrapper'>
                <p><img src={location}></img> Bengaluru</p>
                <p> $ 50k-70k</p>
                <p>4 Days Remaining</p>
              </div>
            </div>
            <div className='right_jobs_div'>
              <div className='bookmark_div'>
                <img src={bookmark} />
              </div>
              <button>Apply Now
                <img src={arrow2} /></button>
            </div>


          </div>
          <div className='feature_jobs'>
            <div className='left_jobs_div'>
              <div className='job_post_wrapper'>
                <h4>Senior UX Designer</h4>
                <button>Development & IT</button>
              </div>
              <p className='job_type'>Full-Time Job</p>
              <div className='job_details_wrapper'>
                <p><img src={location}></img> Bengaluru</p>
                <p> $ 50k-70k</p>
                <p>4 Days Remaining</p>
              </div>
            </div>
            <div className='right_jobs_div'>
              <div className='bookmark_div'>
                <img src={bookmark} />
              </div>
              <button>Apply Now
                <img src={arrow2} /></button>
            </div>


          </div>
          <div className='feature_jobs'>
            <div className='left_jobs_div'>
              <div className='job_post_wrapper'>
                <h4>Senior UX Designer</h4>
                <button>Development & IT</button>
              </div>
              <p className='job_type'>Full-Time Job</p>
              <div className='job_details_wrapper'>
                <p><img src={location}></img> Bengaluru</p>
                <p> $ 50k-70k</p>
                <p>4 Days Remaining</p>
              </div>
            </div>
            <div className='right_jobs_div'>
              <div className='bookmark_div'>
                <img src={bookmark} />
              </div>
              <button>Apply Now
                <img src={arrow2} /></button>
            </div>


          </div> */}

          {isModalOpen && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <div className="client_in_hand_wrapper">
                  {/* Close Button */}
                  <button
                    className="modal_close_button"
                    onClick={() => setIsModalOpen(!isModalOpen)}
                  >
                    &times;
                  </button>
                  <div className="client_head_div">
                    <h3>Application Form</h3>
                  </div>
                  <div className="community_form_wrapper_div">
                    <form
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "10px",
                      }}
                    >
                      <div className="community_input_flex_wrapper">
                        <div className="form_wrappr">
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Name
                            </label>
                            <div className="community_input_wrapper_div">
                              <input
                                value={formData?.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                placeholder="Enter your name"
                                type="text"
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="community_input_flex_wrapper">
                        <div className="form_wrappr">
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Email
                            </label>
                            <div className="community_input_wrapper_div">
                              <input
                                value={formData?.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                placeholder="Enter your active email address"
                                type="email"
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="community_input_flex_wrapper">
                        <div className="form_wrappr">
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Phone
                            </label>
                            <div className="community_input_wrapper_div">
                              <input
                                value={formData?.phone}
                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                placeholder="Enter your active phone number"
                                type="text"
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="community_input_flex_wrapper">
                        <div className="form_wrappr">
                          <div className="community_form_filed_wrapper">
                            <label className="community_form_label">
                              Resume
                            </label>
                            <div className="community_input_wrapper_div">
                              {formData?.cvFile &&
                                <a href={formData?.cvFile} target="_blank">
                                  {formData?.cvFile?.split('.').pop().toLowerCase() === "docx" || formData?.cvFile?.split('.').pop().toLowerCase() === "doc" ? <><i class="fas fa-2x fa-file-word"></i></> : formData?.cvFile?.split('.').pop().toLowerCase() === "pdf" ? <><i class="fas fa-2x fa-file-pdf"></i></> : "NO file uploaded"}
                                </a>
                              }
                              <input
                                type="file"
                                name="cvFile"
                                className="form-control"
                                onChange={(e) => handleAttachmentUpload(e)}
                                // accept="image/*"
                                accept=".doc,.docx,.pdf"
                              />
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="community_form_submit_div">
                        <button onClick={(e) => handleSubmit(e)}>
                          Submit
                        </button>
                        {/* <button style={{ marginLeft: "1em" }} onClick={() => {
                          setIsModalOpen(!isModalOpen);
                        }}>
                          Cancel
                        </button> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>

      </div>
    </>
  )
}

export default FeaturedJobs
